import { Box, Divider } from '@mui/material';

import { ReactNode } from 'react';

interface FooterProps {
  children: ReactNode;
}

function Footer(props: FooterProps) {
  return (
    <Box>
      <Divider />
      <Box bgcolor={'background.paper'} px={2} py={2.5}>
        {props.children}
      </Box>
    </Box>
  );
}

export { Footer };
